import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import toastr from "toastr"

import { OrderCreationRequest, OrderCreationResponse, OrderPayload } from "types"

interface UseCreateOrderMutationParams {
  deviceId?: string
  onOrderCreated?: (data: OrderCreationResponse) => void
}

export const useCreateOrderMutation = ({ 
  deviceId,
  onOrderCreated 
}: UseCreateOrderMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (orderRequest: OrderPayload | OrderCreationRequest): Promise<OrderCreationResponse> => {
      const headers: Record<string, string> = {}
      
      // If deviceId is provided, add it as a header (for select-tickets flow)
      if (deviceId) {
        headers["X-GB-UID"] = deviceId
      }
      
      const response = await axios.post(
        `/api/registration/order/`,
        orderRequest,
        { headers }
      )
      return response.data
    },
    onSuccess: (data: OrderCreationResponse) => {
      // Invalidate related queries that might be affected by the new order
      queryClient.invalidateQueries({ queryKey: ["order"] })
      
      // Call custom success handler if provided (for select-tickets navigation)
      if (onOrderCreated) {
        onOrderCreated(data)
      }
    },
    onError: (error: any) => {
      const message = String(
        error.response?.data?.message || error.response?.data?.[0] || "Failed to create order"
      )
      toastr.error(message, "Failed to create order")
      console.error("Failed to create order:", error)
    },
  })
}